import {select, put, fork, take} from 'redux-saga/effects';
import {etmTaskCategoryTypes, etmTaskStatusTypes} from '@ace-de/eua-entity-types';
import {selectSearchQueryParams} from '@computerrock/formation-router/sagas';
import config from '../../config';
import * as taskActionTypes from '../../tasks/taskActionTypes';
import fetchRequest from '../../application/sagas/fetchRequest';
import serviceCaseScreenTabs from '../serviceCaseScreenTabs';
import ecsAccessControl from '../../ecsAccessControl';
import {ecsFeatures, ecsFeatureActions} from '../../application/ecsFeatures';

const loadServiceCaseToDoTaskCount = function* loadServiceCaseToDoTaskCount({payload}) {
    const {match} = payload;
    const {serviceCaseId} = match.params;
    const {activeTab} = yield* selectSearchQueryParams();
    const isTaskListAvailable = ecsAccessControl.grantFeatureAccess(ecsFeatures.TASK, ecsFeatureActions.READ);

    if (!serviceCaseId
        || !Object.values(serviceCaseScreenTabs).includes(activeTab)
        || config.IS_FALLBACK_SYSTEM
        || !isTaskListAvailable) return;

    const {serviceManager} = yield select(state => state.application);
    const emtFlowService = serviceManager.loadService('ecsTaskManagementService');

    const searchQueryParams = new URLSearchParams();
    searchQueryParams.append('assignedCaseId', serviceCaseId);
    searchQueryParams.append('category', etmTaskCategoryTypes.TODO);
    searchQueryParams.append('status', etmTaskStatusTypes.DUE);
    searchQueryParams.append('status', etmTaskStatusTypes.OVERDUE);

    yield fork(
        fetchRequest,
        taskActionTypes.FETCH_SERVICE_CASE_TASKS_REQUEST,
        emtFlowService.getTasks,
        {
            searchQueryParams,
        },
    );

    const responseAction = yield take([
        taskActionTypes.FETCH_SERVICE_CASE_TASKS_REQUEST_SUCCEEDED,
        taskActionTypes.FETCH_SERVICE_CASE_TASKS_REQUEST_FAILED,
    ]);

    if (responseAction.error) {
        // no-op
    }

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const {taskDTOs} = response;

        yield put({
            type: taskActionTypes.STORE_SERVICE_CASE_TODO_TASK_COUNT,
            payload: {serviceCaseId, toDoTaskCount: taskDTOs.length},
        });
    }
};

export default loadServiceCaseToDoTaskCount;
